
import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  message: string;
  isVisible: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ message, isVisible }) => {
  if (!isVisible) return null;
  
  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full text-center animate-fade-in">
        <Loader2 className="h-12 w-12 text-brand-blue animate-spin mx-auto mb-4" />
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Processing</h3>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;
